// extracted by mini-css-extract-plugin
export default {"card":"TX-z"};